module.exports = __webpack_public_path__ + "static/media/project-01.1a47ef14.png";